import { QuizModule, SanityQuizModule } from "@common";
import { localizedStringArrayToTranslationData } from "../translation";

export function transformSanityQuizModule(quizModule: SanityQuizModule): QuizModule {
  return {
    title: localizedStringArrayToTranslationData(quizModule.title),
    desc: localizedStringArrayToTranslationData(quizModule.desc),
    topic: localizedStringArrayToTranslationData(quizModule.topic),
    colors: [quizModule.colors.color1, quizModule.colors.color2, quizModule.colors.color3],
    isTrainingQuiz: quizModule.isTrainingQuiz,
    icon: quizModule.icon,
    keywords: {
      en: quizModule.keywords.map(
        (keyword) => localizedStringArrayToTranslationData(keyword.keyword).en
      ),
      sv: quizModule.keywords.map(
        (keyword) => localizedStringArrayToTranslationData(keyword.keyword).sv
      ),
    },
    slides: quizModule.slides.map((slide) => slide._id),
    isTeacherModeQuiz: quizModule.isTeacherModeQuiz || false,
  };
}
